import { useParams, useLocation , Link } from "react-router-dom";
import { changeLogService } from "services/Services";
import { useState, useEffect } from "react";
import { ChangeLog } from "models/ChangeLog";
import { UrlPath } from "utility/routes";

const Logg = () => {
  let params = useParams();
  const location = useLocation();
  const [changeLog, setChangeLog] = useState<ChangeLog[]>([]);

  useEffect(() => {
    const getChangeLog = async () => {
      const response = await changeLogService.getChangeLog(params.id as string);
      setChangeLog(response?.changeLog as ChangeLog[]);
    };
    getChangeLog();
  }, [params.id]);
  return (
    <>
      <div className="card">
        <div className="card-body">
          <h1 className="h3">Endringslogg</h1>

          <table className="table cc-table-2-col">
            <tbody>
              <tr>
                <th>Dato</th>
                <th>Endret av</th>
                <th>&nbsp;</th>
              </tr>
              {changeLog?.map((_item, _index) => (
                <tr key={_item.changeLogId}>
                  <td>{_item.date}</td>
                  <td>{_item.user.name}</td>
                  <td>
                  <Link to={`${location.pathname}/${_item.changeLogId}`} state={{ changeLogItem: _item }}>
                    <i
                        className="bi bi-clock-history"
                        title="Vis endringer"
                      ></i>
                      <span className="visually-hidden">Vis endringer</span>
                  </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="mt-4 mb-0">
          <Link to={UrlPath.MyAccount.Home} className="btn btn-outline-primary">
          <i className="bi bi-arrow-left"></i> Tilbake
        </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Logg;
